export class LiveEvent {
    id: number = 0;
    isLive: boolean = false;
    caption: string = "";
    startTime: string = "";
    link: string = "";
}